/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _PrescriptionMedicationEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import ForcBaseComponent, { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import MedicationPrescribedJournalEvent from "core/models/medication-prescribed-journal-event";
import Patient from "core/models/patient";
import MedicationRequest from "core/models/prescriptions/medication-request";
import AnalyticsService from "core/services/analytics";
import { BufferedChangeset } from "ember-changeset/types";
import styles from "./index.module.css";
let PrescriptionMedicationEditionForm = (_class = (_PrescriptionMedicationEditionForm = class PrescriptionMedicationEditionForm extends ForcBaseComponent {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "analytics", _descriptor3, this);
    _initializerDefineProperty(this, "chatMessage", _descriptor4, this);
    _initializerDefineProperty(this, "willSendMessage", _descriptor5, this);
    _defineProperty(this, "hasMedication", (medications, medication) => medications.some(m => m.isEqual(medication)));
    this.chatMessage = "Bonjour,\nJe viens de vous éditer une nouvelle ordonnance. Elle est jointe à ce message.\nBonne journée.";
    this.willSendMessage = true;
  }
  get changeset() {
    return this.args.changeset;
  }
  get isDirty() {
    return this.args.changeset.get("validityPeriod");
  }
  async save() {
    this.forceQuit = true;
    await this.args.changeset.validate();
    if (this.args.changeset.get("isValid")) {
      await this.args.changeset.save();
      const savedModel = this.args.changeset.data;
      if (this.patient.authorizesAppUsage && this.willSendMessage && this.chatMessage.trim()) {
        await this.sendChatMessages();
      }
      this.processRenewAlertTriggered();
      this.router.transitionTo("medics-web.protected.patients.patient.prescriptions.medication-display", savedModel.patient.id, savedModel.id);
    }
  }
  async sendChatMessages() {
    const chatMessageJe = this.store.createRecord("patient-chat-message-sent-journal-event", {
      occurredAt: new Date(),
      patient: this.patient,
      body: this.chatMessage
    });
    this.analytics.trackJeCreation(chatMessageJe);
    await chatMessageJe.save();
    await this.store.createRecord("patient-chat-message-sent-journal-event", {
      occurredAt: new Date(),
      triggeringJournalEvent: this.args.changeset.data,
      patient: this.patient,
      body: "Nouvelle ordonnance reçue"
    }).save();
  }
  processRenewAlertTriggered() {
    const alertsTriggered = this.store.peekAll("alert-triggered-journal-event");
    const alert = alertsTriggered.find(alert => alert.triggeringJournalEvent?.id == this.args.oldMedicationPrescribed?.id);
    if (alert) {
      alert.processAlert({
        actionTaken: "medication-prescription-renewed"
      });
    }
  }
  get latestTreatmentPrescription() {
    return this.patient.lastTreatmentPrescriptionChangedJournalEvent;
  }
  get wholeCarePlanSelected() {
    return this.changeset.get("medications").length === this.latestTreatmentPrescription?.prescriptions.length;
  }
  get hasPps() {
    return !!this.latestTreatmentPrescription?.prescriptions?.length;
  }
  updateChatMessage(event) {
    this.chatMessage = event.target.value;
  }
  toggleCarePlanSelection(checked) {
    if (checked) {
      this.changeset.set("medications", this.latestTreatmentPrescription?.prescriptions.slice());
    } else {
      this.changeset.set("medications", []);
    }
  }
  togglePrescription(prescription) {
    let selection = this.changeset.get("medications").slice();
    const finded = selection.find(m => m.isEqual(prescription));
    if (finded) {
      selection = selection.filter(m => !m.isEqual(prescription));
    } else {
      selection.push(prescription);
    }
    this.changeset.set("medications", selection);
  }

  /**
   * Roll backs changeset and do transition.
   * The changeset is rolled back in case the Medic already start completed
   * the form. This ensure no "Are you sure you want to leave the form" alert is
   * shown, and fixes a "too many recursion error" if this alert is displayed.
   */
  showTreatmentForm() {
    this.changeset.rollback();
    this.router.transitionTo(`medics-web.protected.patients.patient.treatment.edition-form`, this.patient);
  }
  appendVaccine(changeset, str) {
    const prevVaccins = changeset.get("otherMedicationsAld") || "";
    switch (str) {
      case "Vaccination anti-grippale":
        changeset.set("otherMedicationsAld", `${prevVaccins}` + "• VACCINATION ANTI-GRIPPALE\n    1 injection IM dès que le vaccin est disponible\n");
        break;
      case "Vaccination anti-pneumocoque (PREVENAR 13, PNEUVOVAX)":
        changeset.set("otherMedicationsAld", `${prevVaccins}` + "• VACCINATION ANTI-PNEUMOCOQUE\n    PREVENAR 13 : 1 injection IM puis 8 semaines plus tard\n    PNEUMOVAX : 1 injection IM \n");
        break;
      case "Rappel de vaccination anti-pneumocoque (PNEUMOVAX)":
        changeset.set("otherMedicationsAld", `${prevVaccins}` + "• RAPPEL DE VACCINATION ANTI-PNEUMOCOQUE\n    PNEUMOVAX : 1 injection IM \n");
        break;
      case "Vaccination anti covid":
        changeset.set("otherMedicationsAld", `${prevVaccins}` + "• Vaccination anti-COVID en très haute priorité\n");
        break;
    }
  }
  get suggestionComments() {
    return ["Vaccination anti-grippale", "Vaccination anti-pneumocoque (PREVENAR 13, PNEUVOVAX)", "Rappel de vaccination anti-pneumocoque (PNEUMOVAX)", "Vaccination anti covid"];
  }
  get validityPeriod() {
    const periodArray = [];
    periodArray.push({
      duration: 1,
      unit: "day"
    });
    for (let i = 2; i <= 13; i++) {
      periodArray.push({
        duration: i,
        unit: "days"
      });
    }
    periodArray.push({
      duration: 1,
      unit: "week"
    }, {
      duration: 2,
      unit: "weeks"
    }, {
      duration: 3,
      unit: "weeks"
    });
    periodArray.push({
      duration: 1,
      unit: "month"
    });
    for (let i = 2; i <= 6; i++) {
      periodArray.push({
        duration: i,
        unit: "months"
      });
    }
    periodArray.push({
      duration: 12,
      unit: "months"
    });
    return periodArray;
  }
}, _defineProperty(_PrescriptionMedicationEditionForm, "fullComponentId", "prescription/medication-edition-form"), _defineProperty(_PrescriptionMedicationEditionForm, "journalEventClass", MedicationPrescribedJournalEvent), _PrescriptionMedicationEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "analytics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "chatMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "willSendMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateChatMessage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateChatMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCarePlanSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCarePlanSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePrescription", [action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePrescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTreatmentForm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showTreatmentForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appendVaccine", [action], Object.getOwnPropertyDescriptor(_class.prototype, "appendVaccine"), _class.prototype), _class);
export { PrescriptionMedicationEditionForm as default };